module.exports = __webpack_public_path__ + "static/media/unsplash-parking-headlights.f0bb3344.jpg";